import { render } from "./CategoryMode.vue?vue&type=template&id=d8fafea0&scoped=true"
import script from "./CategoryMode.vue?vue&type=script&lang=js"
export * from "./CategoryMode.vue?vue&type=script&lang=js"

import "./CategoryMode.vue?vue&type=style&index=0&id=d8fafea0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8fafea0"]])

export default __exports__